import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import { InputProps as StandardInputProps } from "@mui/material/Input/Input";
import { withMemo } from "../withMemo";

const CustomTextInput = (props: {
    className: string;
    name: string;
    placeholder?: string;
    value: string | number | string[];
    onChange?: StandardInputProps["onChange"];
    onClick?: (event: any) => void;
    startAdornmentIcon?: JSX.Element;
    startAdornmentClass?: string;
    endAdornmentIcon?: JSX.Element;
    endAdornmentClass?: string;
    error?: boolean;
    label?: string;
    helperText?: React.ReactNode;
    type?: string;
    multiline?: boolean;
    rows?: number;
    isReadOnly?: boolean;
    sx?: any;
    disabled?: boolean;
}) => {
    return (
        <TextField
            className={props.className}
            sx={props.sx}
            name={props.name}
            placeholder={props.placeholder}
            label={props.label}
            variant="outlined"
            value={props.value}
            onChange={props.onChange}
            onClick={props.onClick}
            color="primary"
            type={props.type || "text"}
            inputMode={"text"}
            error={props.error}
            helperText={props.helperText}
            data-automation={props.name}
            multiline={!!props.multiline}
            disabled={props.disabled}
            rows={props.rows}
            InputProps={{
                startAdornment: (
                    <>
                        {props.startAdornmentIcon ? (
                            <InputAdornment position="start" className={props.startAdornmentClass}>
                                {props.startAdornmentIcon}
                            </InputAdornment>
                        ) : (
                            <></>
                        )}
                    </>
                ),
                endAdornment: (
                    <>
                        {props.endAdornmentIcon && props.value ? (
                            <InputAdornment position="start" className={props.endAdornmentClass}>
                                {props.endAdornmentIcon}
                            </InputAdornment>
                        ) : (
                            <></>
                        )}
                    </>
                ),
                readOnly: props.isReadOnly,
            }}
        />
    );
};

export default withMemo(CustomTextInput, ["value", "error", "placeholder", "helperText", "className", "disabled"]);
